import React from 'react';
import { FiX, FiClock } from 'react-icons/fi';

const FeatureComingSoonModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm z-50 flex justify-center items-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-md my-auto relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
          <FiX size={24} />
        </button>
        <div className="text-center">
          <FiClock className="mx-auto h-16 w-16 text-brand-blue mb-4" />
          <h3 className="text-2xl font-bold text-gray-800 mb-3">Fonctionnalité en développement</h3>
          <p className="text-gray-600 mb-6">
            {message || "Cette fonctionnalité est en cours de développement et sera disponible très bientôt. Merci de votre patience !"}
          </p>
          <button onClick={onClose} className="bg-brand-blue text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-700 transition-colors">
            Compris
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureComingSoonModal;